(() => {
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('#x-header-mobile.active a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const destination = new URL(link.href, window.location.href);
    if (!destination.hash || destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
    // Keep native anchor navigation; use the theme's existing drawer/focus lifecycle.
    window.Alpine?.store('xMobileNav')?.close();
    window.Alpine?.store('xFocusElement')?.removeTrapFocus();
  });
  const controlSelector = '.promotion-grid .button, .shamos-editorial-hero .button, .shamos-benefit-row, .shamos-device-finder__links, .shamos-device-finder__directory, .shamos-style-directory__header, .shamos-style-directory__group, .shamos-style-directory__footer, .theme-template-product .product-info__form-wrapper, .theme-template-product .product-info__customize-picker-wrapper, .theme-template-product variant-picker, .sticky-add-to-cart__wrapper';
  if (!document.querySelector(controlSelector)) return;
  const states = new Map();
  let chatRoot;
  let frame = 0;
  let appObserver;
  const restore = (element, state) => {
    for (const key of ['translate', 'visibility', 'pointer-events']) {
      const original = state.original[key];
      if (original.value) element.style.setProperty(key, original.value, original.priority);
      else element.style.removeProperty(key);
    }
    state.shift = 0;
  };
  const clearControls = (element, controls) => {
    if (!element) return;
    if (!states.has(element)) states.set(element, {
      shift: 0,
      original: Object.fromEntries(['translate', 'visibility', 'pointer-events'].map(key => [key, { value: element.style.getPropertyValue(key), priority: element.style.getPropertyPriority(key) }]))
    });
    const state = states.get(element);
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const base = { left: rect.left, right: rect.right, top: rect.top + state.shift, bottom: rect.bottom + state.shift };
    let required = 0;
    for (const box of controls) {
      if (box.right > base.left - 12 && box.left < base.right + 12 && base.bottom - required > box.top - 12 && base.top - required < box.bottom + 12) required = base.bottom - box.top + 12;
    }
    if (required > Math.max(0, base.top - 16)) {
      element.style.setProperty('visibility', 'hidden');
      element.style.setProperty('pointer-events', 'none');
      return;
    }
    restore(element, state);
    if (required > 0) {
      element.style.setProperty('translate', `0 -${Math.ceil(required)}px`);
      state.shift = Math.ceil(required);
    }
  };
  const update = () => {
    frame = 0;
    for (const [element, state] of states) {
      if (!element.isConnected) {
        restore(element, state);
        states.delete(element);
      }
    }
    const controls = Array.from(document.querySelectorAll(controlSelector))
      .filter(el => getComputedStyle(el).visibility !== 'hidden')
      .map(el => el.getBoundingClientRect())
      .filter(box => box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < window.innerHeight)
      .sort((a, b) => b.top - a.top);
    // The app exposes this launcher as a public CSS part. Only suppress that
    // button when directory content enters its bottom clearance band; leave an open panel untouched.
    const directoryInView = Array.from(document.querySelectorAll('.shamos-style-directory__header, .shamos-style-directory__group, .shamos-style-directory__footer'))
      .some(element => {
        const box = element.getBoundingClientRect();
        return box.width > 0 && box.height > 0 && box.bottom > window.innerHeight - 140 && box.top < window.innerHeight;
      });
    document.body.classList.toggle('shamos-directory-content-in-view', directoryInView);
    clearControls(document.querySelector('.jdgm-revs-tab-btn'), controls);
    const launcher = chatRoot?.querySelector('.activator-nudge');
    const panel = chatRoot?.querySelector('.panel[role="dialog"]');
    if (launcher && panel && panel.getBoundingClientRect().height > 0) {
      if (states.has(launcher)) restore(launcher, states.get(launcher));
    } else clearControls(launcher, controls);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const bind = () => {
    const host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot || host.shadowRoot === chatRoot) return;
    appObserver?.disconnect();
    chatRoot = host.shadowRoot;
    host.addEventListener('click', () => requestAnimationFrame(schedule), { passive: true });
    appObserver = new MutationObserver(schedule);
    appObserver.observe(chatRoot, { childList: true, subtree: true });
    schedule();
  };
  const hostObserver = new MutationObserver(() => {
    bind();
    schedule();
    if (chatRoot && document.querySelector('.jdgm-revs-tab-btn')) hostObserver.disconnect();
  });
  hostObserver.observe(document.body, { childList: true, subtree: true });
  customElements.whenDefined('shopify-chat').then(() => requestAnimationFrame(bind));
  bind();
  schedule();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  const stickyObserver = new MutationObserver(schedule);
  const watchSticky = () => document.querySelectorAll('.sticky-add-to-cart__wrapper').forEach(el => stickyObserver.observe(el, { attributes: true, attributeFilter: ['style', 'class'] }));
  watchSticky();
  document.addEventListener('shopify:section:load', () => { watchSticky(); schedule(); });
  document.addEventListener('change', schedule, { passive: true });
})();
